import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ArticleSchuhe from "@/pages/article/schuhe/page";
import ArticleSicherheit from "@/pages/article/sicherheit/page";
import ArticleVergleich from "@/pages/article/vergleich/page";
import ArticleAnfaenger from "@/pages/article/anfaenger/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-schuhe",
    element: <ArticleSchuhe />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-sicherheit",
    element: <ArticleSicherheit />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-vergleich",
    element: <ArticleVergleich />,
  },
  {
    path: "/artikel/oopbuy-spreadsheet-anfaenger",
    element: <ArticleAnfaenger />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;